import { Injectable } from '@angular/core';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { NomenclatureItemFindInterface } from '@zaoblako/shared/modules/catalog/dtos/nomenclature/nomenclature-item-find.dto';
import type { NomenclatureItemPageInterface } from '@zaoblako/shared/modules/catalog/dtos/nomenclature/nomenclature-item-page.dto';
import type { NomenclatureItemQueryInterface } from '@zaoblako/shared/modules/catalog/dtos/nomenclature/nomenclature-item-query.dto';
import type { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NomenclatureItemService extends BaseService {
  protected baseUrl = '/basis/catalog/nomenclature/item';

  public findWithPagination(queryParams: NomenclatureItemQueryInterface): Observable<NomenclatureItemPageInterface> {
    return this.http.get<NomenclatureItemPageInterface>(this.baseUrl, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public restoreOne(id: number): Observable<NomenclatureItemFindInterface> {
    return this.http.post<NomenclatureItemFindInterface>(`${this.baseUrl}/${id}/restore`, null);
  }

  public getHistoryForOne(id: number, queryParams?: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: queryParams ? this.objectToHttpParams(queryParams) : {}
    });
  }
}
